var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20,
    r: 20,
    fill: "#F2F4F8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_299_1562",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 8,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 8.5,
    width: 22.5,
    height: 22.5,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_299_1562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0469 21.5781V25.0323C20.0469 25.2319 20.1142 25.399 20.2489 25.5337C20.3834 25.6682 20.5505 25.7355 20.75 25.7355C20.9495 25.7355 21.1166 25.6682 21.2511 25.5337C21.3858 25.399 21.4531 25.2319 21.4531 25.0323V21.5781L22.6934 22.8184C22.7633 22.8881 22.8417 22.9404 22.9288 22.9752C23.0159 23.0101 23.1031 23.0252 23.1903 23.0205C23.2773 23.0156 23.3635 22.9958 23.4488 22.9609C23.5341 22.9261 23.6117 22.8738 23.6816 22.8041C23.8173 22.6587 23.8877 22.494 23.8925 22.3101C23.8972 22.1262 23.8269 21.9615 23.6816 21.816L21.3432 19.4777C21.2554 19.39 21.1628 19.3281 21.0655 19.292C20.9681 19.2559 20.863 19.2379 20.75 19.2379C20.637 19.2379 20.5319 19.2559 20.4345 19.292C20.3372 19.3281 20.2446 19.39 20.1568 19.4777L17.8184 21.816C17.6791 21.9555 17.6103 22.1188 17.6122 22.3056C17.6139 22.4925 17.6875 22.6587 17.833 22.8041C17.9784 22.9399 18.1431 23.0102 18.327 23.0151C18.5108 23.0198 18.6754 22.9495 18.8209 22.8041L20.0469 21.5781ZM15.4135 28.6562C14.9399 28.6562 14.5391 28.4922 14.2109 28.1641C13.8828 27.8359 13.7188 27.4351 13.7188 26.9615V12.5385C13.7188 12.0649 13.8828 11.6641 14.2109 11.3359C14.5391 11.0078 14.9399 10.8438 15.4135 10.8438H22.1581C22.3841 10.8438 22.6013 10.8877 22.8099 10.9755C23.0184 11.0631 23.1995 11.1839 23.3534 11.3378L27.2872 15.2716C27.4411 15.4255 27.5619 15.6066 27.6495 15.8151C27.7373 16.0237 27.7812 16.2409 27.7812 16.4669V26.9615C27.7812 27.4351 27.6172 27.8359 27.2891 28.1641C26.9609 28.4922 26.5601 28.6562 26.0865 28.6562H15.4135ZM22.1562 15.6213V12.25H15.4135C15.3413 12.25 15.2752 12.2801 15.2152 12.3402C15.1551 12.4002 15.125 12.4663 15.125 12.5385V26.9615C15.125 27.0337 15.1551 27.0998 15.2152 27.1598C15.2752 27.2199 15.3413 27.25 15.4135 27.25H26.0865C26.1587 27.25 26.2248 27.2199 26.2848 27.1598C26.3449 27.0998 26.375 27.0337 26.375 26.9615V16.4688H23.0037C22.762 16.4688 22.5604 16.3879 22.3988 16.2262C22.2371 16.0646 22.1562 15.863 22.1562 15.6213Z",
    fill: "#1A1A1A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFileIcon);
export default __webpack_public_path__ + "static/media/upload-file-icon.e0989efb34da4c3212a874b9293e2a34.svg";
export { ForwardRef as ReactComponent };